

<div class="flex justify-content-between align-items-center flex-shrink-0 mb-2">
	@if (!modal) {
		<h1 class="flex align-items-center m-0">
			<back-button class="flex-shrink-0"></back-button>

			<div class="vignette-display mr-2">
				@switch (media.tym_code) {
					@case ('image') {
						<div class="center-all">
							<media-display [media]="media" [showTitle]="false"></media-display>
						</div>
					}
					@default {
						<media-icon [tym_code]="media.tym_code"></media-icon>
					}
				}
			</div>

			<span>{{media.med_titre}}</span>

		</h1>
	}

	<div class="flex-shrink-0">
		@if (menuItems.length) {
			<button
				type="button"
				pButton
				icon="pi pi-bars"
				class="label-md-none"
				[loading]="loading"
				(click)="menu.toggle($event)"
			></button>
		}
		<p-menu #menu [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
	</div>
</div>

<p-card>

	@if (media._type != 'lien') {
		<media-display [media]="media" [consultation]="true" [showPdf]="true"></media-display>
	}

	<ng-template pTemplate="footer">

		@if (media.med_url) {
			<div>
				<div>Url : <a href="{{media.med_url}}">{{media.med_url}}</a></div>
			</div>
		}
		@if (media.med_fichier) {
			<div>
				@if (media.med_fichier != media.med_titre) {
					<div class="text-sm">Nom fichier: {{media.med_fichier}}</div>
				}
				<div class="text-sm">Taille : {{media.med_taille!|formatSize}}</div>
			</div>
		}

		@if (media.med_description) {
			<div class="mt-2">{{media.med_description}}</div>
		}
	</ng-template>

</p-card>

